import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Imprint = () => {
  return (
    <div className="min-h-screen bg-white">
      <header className="border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="text-2xl font-heading font-bold">
            <span className="text-primary">Job</span>Match
          </Link>
          <Link to="/">
            <Button variant="ghost" className="gap-2">
              <ArrowLeft className="w-4 h-4" />
              Zurück
            </Button>
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16" data-testid="imprint-page">
        <h1 className="text-3xl font-heading font-bold text-gray-900 mb-8">Impressum</h1>

        <div className="space-y-6 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Angaben gemäß § 5 TMG</h2>
            <p>E. Decker</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Kontakt</h2>
            <p>E-Mail: info@jobmatch.de</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV</h2>
            <p>E. Decker</p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Haftungsausschluss</h2>
            <p>
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links.
              Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
            </p>
          </section>
        </div>
      </main>

      <footer className="py-12 px-6 border-t border-gray-100">
        <div className="max-w-7xl mx-auto text-center text-sm text-gray-500">
          © {new Date().getFullYear()} JobMatch. Alle Rechte vorbehalten.
        </div>
      </footer>
    </div>
  );
};

export default Imprint;
